const cryptoJs = require('crypto-js')
var encKey = process.env.ENC_KEY

export function ENC (data) {
  var bytes = cryptoJs.AES.decrypt(data, encKey)
  var decryptedData = bytes.toString(cryptoJs.enc.Utf8)
  return decryptedData
}



// WEBPACK FOOTER //
// ./src/decrypt_pwd.js